// extracted by mini-css-extract-plugin
module.exports = {"SpinnerWrapper":"App_SpinnerWrapper__2lqlo","TextHeader":"App_TextHeader__udzA-"};